import { useEffect, useState } from "react";
import { C } from "../../styles/theme";
import SecHdr from "../common/SecHdr";
import Avatar from "../common/Avatar";
import Stars from "../common/Stars";

export default function Testimonials({ items }) {
  const pub = (items || []).filter(t => t.status === "published");
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!pub.length) return;
    const t = setInterval(() => setIdx(i => (i + 1) % pub.length), 5000);
    return () => clearInterval(t);
  }, [pub.length]);
  if (!pub.length) return null;
  const t = pub[idx] || pub[0];
  return (
    <div className="section" style={{ background: "#f5f7fb", borderBottom: "1px solid #D8E2EE" }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <SecHdr tag="Client Stories" title="What Our Clients Say" sub="Trusted by leading companies across India." />
        <div style={{ background: "#fff", border: "1px solid #D8E2EE", borderRadius: 18, padding: "40px 44px", boxShadow: "0 4px 16px rgba(12,31,63,.08)" }}>
          <div style={{ fontSize: 52, color: "#E8593C", lineHeight: 1, marginBottom: 16, opacity: .25 }}>"</div>
          <p style={{ fontSize: 16, color: "#0C1F3F", lineHeight: 1.85, marginBottom: 24 }}>{t.text}</p>
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 18 }}>
            <Avatar src={t.image} name={t.name} size={56} border={true} />
            <div style={{ flex: 1 }}>
              <div style={{ color: C.blue, fontWeight: 700, fontSize: 14.5 }}>{t.name}</div>
              <div style={{ color: "#E8593C", fontSize: 12.5, marginTop: 3, fontWeight: 600 }}>{t.role}, {t.company}</div>
            </div>
            <Stars n={t.rating} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button onClick={() => setIdx(i => (i - 1 + pub.length) % pub.length)} style={{ background: "#f5f7fb", border: "1px solid #D8E2EE", color: "#0C1F3F", width: 34, height: 34, borderRadius: "50%", cursor: "pointer", fontSize: 15, display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s" }}>‹</button>
            <div style={{ display: "flex", gap: 5 }}>{pub.map((_, i) => <span key={i} onClick={() => setIdx(i)} style={{ width: i === idx ? 20 : 6, height: 6, borderRadius: 3, background: i === idx ? "#E8593C" : "#D8E2EE", cursor: "pointer", transition: "width .3s" }} />)}</div>
            <button onClick={() => setIdx(i => (i + 1) % pub.length)} style={{ background: "#f5f7fb", border: "1px solid #D8E2EE", color: "#0C1F3F", width: 34, height: 34, borderRadius: "50%", cursor: "pointer", fontSize: 15, display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s" }}>›</button>
          </div>
        </div>
      </div>
    </div>
  );
}
